import * as z from "zod";

const FulfillmentCutoffDayOfWeekSchema = z.object({
  activeFulfillmentDay: z.boolean(),
  cutoffTime: z.string().nullable(),
});

export const ShippingFulfillmentPromiseFlatTeamSettingsSchema = z.object({
  "outboundLabels/fulfillmentPromiseDays": z.number().nullish(),
  "checkoutOptimization/fulfillmentCutoffSchedule": z
    .object({
      timezone: z.string(),
      monday: FulfillmentCutoffDayOfWeekSchema,
      tuesday: FulfillmentCutoffDayOfWeekSchema,
      wednesday: FulfillmentCutoffDayOfWeekSchema,
      thursday: FulfillmentCutoffDayOfWeekSchema,
      friday: FulfillmentCutoffDayOfWeekSchema,
      saturday: FulfillmentCutoffDayOfWeekSchema,
      sunday: FulfillmentCutoffDayOfWeekSchema,
    })
    .nullish(),
});
